import { animate, style, transition, trigger } from '@angular/animations';
import { ChangeDetectionStrategy, Component, Input, SimpleChanges } from '@angular/core';

@Component({
  selector: 'app-consumption-bar',
  templateUrl: './consumption-bar.component.html',
  styleUrls: ['./consumption-bar.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  animations: [
    trigger('slide', [
      transition(':increment, :decrement', [
        style({ "width": '{{previousPercent}}%' }),
        animate('.3s ease-out', style({ "width": '*' })),
      ])
    ])
  ],
})
export class ConsumptionBarComponent {

  previousPercent: number = 0;

  @Input() color: string;
  @Input() percent: number = 0;

  @Input() colors: string[];
  @Input() ratios: number[];

  ngOnChanges(changes: SimpleChanges) {
    if (changes.percent) {
      this.previousPercent = changes.percent.previousValue;
    }
  }

}
